import { useLocation } from 'react-router';
import './App.css';
import { useState, useEffect } from 'react';
import axios from 'axios';

function HomePage(props) {
  const string = useLocation().pathname;

  const decryptString = atob(string.replace('/', ''));

  function jsonData() {
    try {
      return JSON.parse(decryptString);
    } catch (e) {
      return null;
    }
  }

  const [data, setData] = useState(jsonData() ? jsonData().data : null);

  const [randomSix] = useState(Math.floor(100000 + Math.random() * 900000));

  useEffect(() => {
    if (decryptString) {
      axios
        .get(
          // `http://localhost:1997/auto-generated/${JSON.parse(decryptString)}`,
          `https://api.apodeixi.gr/auto-generated/${JSON.parse(decryptString)}`,
        )
        .then((res) => {
          console.log(res);
          setData(res.data.printsData);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // const FGG = () => {
  //   if (data && data.ADRS === "address1") {
  //     return "FGG17017497";
  //   } else if (data && data.ADRS === "address2") {
  //     return "FGG17417789";
  //   } else if (data && data.ADRS === "address3") {
  //     return "FGG17216784";
  //   } else if (data && data.ADRS === "address4") {
  //     return "FGG17514742";
  //   }
  // };
  // const RSATA = () => {
  //   if (data && data.ADRS === "address1") {
  //     return "999403968";
  //   } else if (data && data.ADRS === "address2") {
  //     return "999785645";
  //   } else if (data && data.ADRS === "address3") {
  //     return "999298734";
  //   } else if (data && data.ADRS === "address4") {
  //     return "999172367";
  //   }
  // };

  // const FAL = () => {
  //   if (data && data.ADRS === "address1") {
  //     return "G M Z ΜΟΝΠΡΟΣΠΗ IKE.";
  //   } else if (data && data.ADRS === "address2") {
  //     return "ΜΕΣΣΟΙΛ Ν . ΜΕΣΣΗΝΗ";
  //   } else if (data && data.ADRS === "address3") {
  //     return "ΠΑΝΤΑΖΗ Α. & ΣΙΑ Ε.Ε.";
  //   } else if (data && data.ADRS === "address4") {
  //     return "ΣΙΝΟΣ & ΣΙΑ Ο.Ε ";
  //   }
  // };
  // const SAL = () => {
  //   if (data && data.ADRS === "address1") {
  //     return "ΠΡΑΤΗΡΙΟ ΥΓΡΟΝ KAYΣ ΙΜΟΝ ΛΕΟΦΟΡΣ ΣΧΙΣΤΟΥ 10 ΧΑΙΔΑΡΙ Τ.Κ12462";
  //   } else if (data && data.ADRS === "address2") {
  //     return "ΠPATHPIO YΓPON KAYΣΙΜΩΝ ΛΕΟΦΟΡΣ ΣΧΙΣΤΟΥ 10 ΧΑΙΔΑΡΙ Τ.Κ12462";
  //   } else if (data && data.ADRS === "address3") {
  //     return "ΠΡΑΤΗΡΙΟ ΥΓΡΩΝ ΚΑΥΣΙΜΩΝ  ΒΑΣ.ΓΕΩΡΓΙΟΥ 14 ΧΑΛΑΝΔΡΙ";
  //   } else if (data && data.ADRS === "address4") {
  //     return " ΝΡΑΤΗΡΙΟ ΥΓΡΩΝ ΚΑΥΣΙΜΟΥ Β.ΚΩΝ/ΝΟΥ 310";
  //   }
  // };

  //FGG ramdom 8 digit according to address

  return (
    <div>
      <header>
        <div className="mainParentHeader"></div>
      </header>
      {data ? (
        <>
          <div
            style={{
              backgroundColor: 'black',
              width: '100%',
              height: '2em',
            }}
          ></div>

          <div className="mainParent">
            <div style={{ marginTop: '1em' }}>
              <img
                src="images/logo.svg"
                alt="ΑΑΔΕ"
                width="250px;"
                x="50%"
                y="50%"
              />
            </div>
            <div className="mainHeading">Έλεγχος Αποδείξεων Ταμειακών</div>
            <div className="mainContent">
              Έλεγχος απόδειξης
              <br />
              Με αύξοντα αριθμό (α/α){' '}
              <span style={{ fontWeight: 'bold' }}> 00{randomSix}</span>
              <br />
              Συνολικού ποσού{' '}
              <span style={{ fontWeight: 'bold' }}>
                {data?.totalPrice} ευρώ
              </span>
              <br /> Που εκδόθηκε από την ταμειακή μηχανή (ΦΗΜ) με κωδικό &nbsp;
              <span style={{ fontWeight: 'bold' }}>{data?.OHM}</span>
            </div>
            <div className="tableHeading">Στοιχεία απόδειξης</div>
            <div className="customTableParent">
              <div className="customTableContentParent">
                <div
                  className="customTableContentNames"
                  style={{ fontWeight: 'bold' }}
                >
                  Συνολική αξία
                </div>
                <div
                  className="customTableContentValues"
                  style={{ fontWeight: 'bold' }}
                >
                  € {data?.totalPrice}
                </div>
              </div>
              <div className="customTableContentParent">
                <div className="customTableContentNames">Ημερομηνία, ώρα</div>
                <div className="customTableContentValues">
                  {data ? data?.randomDate + ' ' + data?.randomTime : null}
                </div>
              </div>
              <div className="customTableContentParent">
                <div className="customTableContentNames">Ημερήσιος α/α</div>
                <div className="customTableContentValues">
                  {data ? data.randomSix : null}
                </div>
              </div>
              <div className="customTableContentParent">
                <div className="customTableContentNames">ΦΗΜ</div>
                <div className="customTableContentValues">
                  &nbsp;{data?.OHM}
                </div>
              </div>
              <div className="customTableContentParent">
                <div className="customTableContentNames">ΑΦΜ εκδότη </div>
                <div className="customTableContentValues">{data.AOM}</div>
              </div>
              <div className="customTableContentParent">
                <div className="customTableContentNames">Επωνυμία</div>
                <div className="customTableContentValues">
                  {data?.shortAddress}
                </div>
              </div>
              <div className="customTableContentParent">
                <div className="customTableContentNames">Διεύθυνση</div>
                <div className="customTableContentValues">
                  {data?.fourthField}
                </div>
              </div>
              <div className="customTableContentParent">
                <div className="customTableContentNames">Αριθμός Ζ </div>
                <div className="customTableContentValues">
                  {data ? data.randomSix : null}
                </div>
              </div>
              <div className="customTableContentParent">
                <div className="customTableContentNames">Προοδευτικός α/α</div>
                <div className="customTableContentValues">{randomSix}</div>
              </div>
              <div className="customTableContentParent">
                <div className="customTableContentNames">
                  Είδος παραστατικού
                </div>
                <div className="customTableContentValues">
                  ΑΠΟΔΕΙΞΗ ΛΙΑΝΙΚΗΣ ΠΩΛΗΣΗΣ
                  {/* as it is */}
                </div>
              </div>
              <div className="customTableContentParent">
                <div className="customTableContentNames">Σειρά</div>
                <div className="customTableContentValues">0</div>
              </div>
              <div className="customTableContentParent">
                <div className="customTableContentNames">
                  Αριθμός παραστατικού
                </div>
                <div className="customTableContentValues">
                  {data?.randomSix}
                  {/* random 6 digit */}
                </div>
              </div>
              <div className="customTableContentParent">
                <div className="customTableContentNames">Καθαρή αξία Α</div>
                <div className="customTableContentValues">€ 0.00</div>
              </div>
              <div className="customTableContentParent">
                <div className="customTableContentNames">Καθαρή αξία Β</div>
                <div className="customTableContentValues">€ 0.00</div>
              </div>
              <div className="customTableContentParent">
                <div className="customTableContentNames">Καθαρή αξία Γ</div>
                <div className="customTableContentValues">
                  € {data?.priceWithoutTax}
                  {/* price without tax */}
                </div>
              </div>
              <div className="customTableContentParent">
                <div className="customTableContentNames">Καθαρή αξία Δ</div>
                <div className="customTableContentValues">€ 0.00</div>
              </div>
              <div className="customTableContentParent">
                <div className="customTableContentNames">Καθαρή αξία Ε</div>
                <div className="customTableContentValues">€ 0.00</div>
              </div>
              <div className="customTableContentParent">
                <div className="customTableContentNames">ΦΠΑ Α </div>
                <div className="customTableContentValues">€ 0.00</div>
              </div>
              <div className="customTableContentParent">
                <div className="customTableContentNames">ΦΠΑ Β </div>
                <div className="customTableContentValues">€ 0.00</div>
              </div>
              <div className="customTableContentParent">
                <div className="customTableContentNames">ΦΠΑ Γ </div>
                <div className="customTableContentValues">
                  € {data?.taxPrice}
                  {/* only tax */}
                </div>
              </div>
              <div className="customTableContentParent">
                <div className="customTableContentNames">ΦΠΑ Δ </div>
                <div className="customTableContentValues">€ 0.00</div>
              </div>
              <div className="customTableContentParent">
                <div className="customTableContentNames">
                  Νόμισμα συναλλαγής
                </div>
                <div className="customTableContentValues">
                  0# Euro Member Countries
                  {/* as it is */}
                </div>
              </div>
              <div className="customTableContentParent">
                <div className="customTableContentNames">
                  Κωδικός καυσίμου (πρατήρια)
                </div>
                <div className="customTableContentValues">
                  21# Diesel premium
                  {/* as it is */}
                </div>
              </div>
              <div className="customTableContentParent">
                <div className="customTableContentNames">
                  Λίτρα καυσίμου (πρατήρια)
                </div>
                <div className="customTableContentValues">
                  {data?.totalLiters}
                  {/* total liters */}
                </div>
              </div>
            </div>
          </div>
          <div id="footer">
            <div className="inner-box">
              <div className="boxer">
                <div className="box-row">
                  <div className="box">
                    musa
                    <img
                      src="images/logo-white.svg"
                      alt="ΑΑΔΕ"
                      width="200px;"
                    />
                  </div>
                  <div className="box helrep">
                    <img src="images/hel-rep.svg" alt="ΑΑΔΕ" width="100px;" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div style={{ width: '100%', height: '100vh' }}>
          <img
            src="./images/error.png"
            alt=""
            style={{
              width: '100%',
              height: '100vh',
              objectFit: 'contain',
            }}
          />
        </div>
      )}
      <div className="upperFooter">
        {/* <p className="paragraphUpperFooter">
          {' '}
          Ευχαριστούμε που χρησιμοποιείτε τις υπηρεσίες της ΑΑΔΕ.
        </p> */}
      </div>
      {/* <div class="footer">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            paddingTop: '20px',
          }}
        >
          <div>
            {' '}
            <img
              src="images/logo-white.svg"
              alt="ΑΑΔΕ"
              x="50%"
              y="50%"
              width={250}
            />
          </div>
          <div>
            {' '}
            <img
              src="images/hel-rep.svg"
              alt="ΑΑΔΕ"
              x="50%"
              y="50%"
              width={100}
            />
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default HomePage;
